import axios from "axios";


export const getAiProductsPricing = async (authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/admin/ai-products`, {}, {
        headers: {
            authtoken,
        },
    });

export const getAiProducts = async () =>
    await axios.get(`${process.env.REACT_APP_API}/ai-products`);


export const calculateResult = async (authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/ai-products/calculate`, {}, {
        headers: {
            authtoken,
        },
    });

export const calculateMargin = async (expetedMargin, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/ai-products/calculate-margin`, {expetedMargin}, {
        headers: {
            authtoken,
        },
    });
